import { getConstantsFor } from '../asyncAction';

export const GEOCODE_LOCATION = getConstantsFor('GEOCODE_LOCATION');
